const config = Object.assign({}, window.shopLocalizer || window.shopExplorerData || {});

export function getNonce() {
	return config.nonce;
}


export function isPro() {
	return config.isPro;
}

export function ran_setup_wizard() {
	return config.ran_setup_wizard;
}

export function getNoticeData() {
	return config.notice_settings;
}

